const Templates = [
    {
        "Name": "Logo Left Aligned",
        "IsDefault": true,
        "Type": "certificates",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "columnsTwo-header-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "col1_width": "66",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "fontStyleCompany": "normal",
                                    "textTransformCompany": "none",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px",
                                    "fontStyleAddress": "normal",
                                    "textTransformAddress": "none"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-header-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "text-default",
                "Type": "text",
                "Config": {
                    "Block": {
                        "displayText": "Certificate of Authenticity",
                        "style": "body",
                        "fontStyle": "normal",
                        "fontSize": ""
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsTwo-default",
                            "Type": "columnsTwo",
                            "Config": {
                                "Block": {
                                    "col1_width": "",
                                    "col1_verticalAlign": "middle",
                                    "col1_collapseIfEmpty": false,
                                    "col2_width": "500px",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false,
                                    "col1_paddingRight": "10px"
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": false,
                                    "col1_style": "body",
                                    "col1_fontStyle": "normal",
                                    "col1_verticalAlign": "middle",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_fontStyle": "normal",
                                    "col2_verticalAlign": "middle",
                                    "col2_textAlign": "left"
                                },
                                "Style": {}
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Artist: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Title: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Includes": {
                                                "Edition": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemYear-default",
                                        "Type": "itemYear",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Year: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Year": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Medium: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSignature-default",
                                        "Type": "itemSignature",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Signature: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Signature": false
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Size: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Price: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            },
                                            "Format": {
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Inventory #: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "SKU: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "500px",
                                                "maxHeight": "100%"
                                            },
                                            "Style": {
                                                "textAlign": "center"
                                            }
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "Id": "separator-default",
                            "Type": "separator",
                            "Config": {
                                "Block": {
                                    "color": "#e9e9e9"
                                },
                                "Style": {
                                    "paddingTop": "20px",
                                    "paddingBottom": "20px"
                                }
                            }
                        },
                        {
                            "Id": "itemArtistBio-default",
                            "Type": "itemArtistBio",
                            "Config": {
                                "Block": {
                                    "borderBottom": "1px solid #e9e9e9",
                                    "borderBottomSpacing": "20px",
                                    "styleName": "body",
                                    "fontStyleName": "normal",
                                    "textTransformName": "none",
                                    "styleBio": "body",
                                    "fontStyleBio": "normal",
                                    "textTransformBio": "none",
                                    "fontSizeName": "",
                                    "fontSizeBio": ""
                                },
                                "Includes": {
                                    "ArtistName": true
                                },
                                "Visibility": {
                                    "ArtistBio": true
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "statement-default",
                "Type": "statement",
                "Config": {
                    "Block": {
                        "borderBottom": "1px solid #e9e9e9",
                        "borderBottomSpacing": "20px",
                        "style": "body",
                        "fontStyle": "normal",
                        "textTransform": "none"
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "signature-default",
                "Type": "signature",
                "Config": {
                    "Block": {
                        "labelTextSignature": "Signature: ",
                        "styleSignature": "body",
                        "fontSizeSignature": "16px",
                        "lineHeightSignature": "19px",
                        "fontStyleSignature": "normal",
                        "labelTextDate": "Date: ",
                        "styleDate": "body",
                        "fontSizeDate": "16px",
                        "lineHeightDate": "19px",
                        "fontStyleDate": "normal",
                        "dateWidth": "40",
                        "spacing": "80px"
                    },
                    "Includes": {
                        "Date": true
                    },
                    "Style": {}
                }
            }
        ],
        "Migration": {
            "itemSignature": true
        }
    },
    {
        "Name": "Logo Right Aligned",
        "IsDefault": false,
        "Type": "certificates",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "columnsTwo-header-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "col1_width": "",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "66",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "fontStyleCompany": "normal",
                                    "textTransformCompany": "none",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px",
                                    "fontStyleAddress": "normal",
                                    "textTransformAddress": "none"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-header-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "text-default",
                "Type": "text",
                "Config": {
                    "Block": {
                        "displayText": "Certificate of Authenticity",
                        "style": "body",
                        "fontStyle": "normal"
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsTwo-default",
                            "Type": "columnsTwo",
                            "Config": {
                                "Block": {
                                    "col1_width": "",
                                    "col1_verticalAlign": "middle",
                                    "col1_collapseIfEmpty": false,
                                    "col2_width": "500px",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false,
                                    "col1_paddingRight": "10px"
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": false,
                                    "col1_style": "body",
                                    "col1_fontStyle": "normal",
                                    "col1_verticalAlign": "middle",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_fontStyle": "normal",
                                    "col2_verticalAlign": "middle",
                                    "col2_textAlign": "left"
                                },
                                "Style": {}
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Artist: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Title: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Includes": {
                                                "Edition": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemYear-default",
                                        "Type": "itemYear",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Year: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Year": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Medium: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSignature-default",
                                        "Type": "itemSignature",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Signature: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Signature": false
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Size: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Price: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            },
                                            "Format": {
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Inventory #: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "SKU: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "500px",
                                                "maxHeight": "100%"
                                            },
                                            "Style": {
                                                "textAlign": "center"
                                            }
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "Id": "separator-default",
                            "Type": "separator",
                            "Config": {
                                "Block": {
                                    "color": "#e9e9e9"
                                },
                                "Style": {
                                    "paddingTop": "20px",
                                    "paddingBottom": "20px"
                                }
                            }
                        },
                        {
                            "Id": "itemArtistBio-default",
                            "Type": "itemArtistBio",
                            "Config": {
                                "Block": {
                                    "borderBottom": "1px solid #e9e9e9",
                                    "borderBottomSpacing": "20px",
                                    "styleName": "body",
                                    "fontStyleName": "normal",
                                    "textTransformName": "none",
                                    "styleBio": "body",
                                    "fontStyleBio": "normal",
                                    "textTransformBio": "none"
                                },
                                "Includes": {
                                    "ArtistName": true
                                },
                                "Visibility": {
                                    "ArtistBio": true
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "statement-default",
                "Type": "statement",
                "Config": {
                    "Block": {
                        "borderBottom": "1px solid #e9e9e9",
                        "borderBottomSpacing": "20px",
                        "style": "body",
                        "fontStyle": "normal",
                        "textTransform": "none"
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "signature-default",
                "Type": "signature",
                "Config": {
                    "Block": {
                        "labelTextSignature": "Signature: ",
                        "styleSignature": "body",
                        "fontSizeSignature": "16px",
                        "lineHeightSignature": "19px",
                        "fontStyleSignature": "normal",
                        "labelTextDate": "Date: ",
                        "styleDate": "body",
                        "fontSizeDate": "16px",
                        "lineHeightDate": "19px",
                        "fontStyleDate": "normal",
                        "dateWidth": "40",
                        "spacing": "80px"
                    },
                    "Includes": {
                        "Date": true
                    },
                    "Style": {}
                }
            }
        ],
        "Migration": {
            "itemSignature": true
        }
    },
    {
        "Name": "Logo Centered",
        "IsDefault": false,
        "Type": "certificates",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "100%",
                        "maxHeight": "75px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "separator-header-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "text-default",
                "Type": "text",
                "Config": {
                    "Block": {
                        "displayText": "Certificate of Authenticity",
                        "style": "body",
                        "fontStyle": "normal"
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsTwo-default",
                            "Type": "columnsTwo",
                            "Config": {
                                "Block": {
                                    "col1_width": "",
                                    "col1_verticalAlign": "middle",
                                    "col1_collapseIfEmpty": false,
                                    "col2_width": "500px",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false,
                                    "col1_paddingRight": "10px"
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": false,
                                    "col1_style": "body",
                                    "col1_fontStyle": "normal",
                                    "col1_verticalAlign": "middle",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_fontStyle": "normal",
                                    "col2_verticalAlign": "middle",
                                    "col2_textAlign": "left"
                                },
                                "Style": {}
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Artist: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Title: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Includes": {
                                                "Edition": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemYear-default",
                                        "Type": "itemYear",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Year: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Year": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Medium: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSignature-default",
                                        "Type": "itemSignature",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Signature: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Signature": false
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Size: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Price: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            },
                                            "Format": {
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Inventory #: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "SKU: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "500px",
                                                "maxHeight": "100%"
                                            },
                                            "Style": {
                                                "textAlign": "center"
                                            }
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "Id": "separator-default",
                            "Type": "separator",
                            "Config": {
                                "Block": {
                                    "color": "#e9e9e9"
                                },
                                "Style": {
                                    "paddingTop": "20px",
                                    "paddingBottom": "20px"
                                }
                            }
                        },
                        {
                            "Id": "itemArtistBio-default",
                            "Type": "itemArtistBio",
                            "Config": {
                                "Block": {
                                    "borderBottom": "1px solid #e9e9e9",
                                    "borderBottomSpacing": "20px",
                                    "styleName": "body",
                                    "fontStyleName": "normal",
                                    "textTransformName": "none",
                                    "styleBio": "body",
                                    "fontStyleBio": "normal",
                                    "textTransformBio": "none"
                                },
                                "Includes": {
                                    "ArtistName": true
                                },
                                "Visibility": {
                                    "ArtistBio": true
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "statement-default",
                "Type": "statement",
                "Config": {
                    "Block": {
                        "borderBottom": "1px solid #e9e9e9",
                        "borderBottomSpacing": "20px",
                        "style": "body",
                        "fontStyle": "normal",
                        "textTransform": "none"
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "signature-default",
                "Type": "signature",
                "Config": {
                    "Block": {
                        "labelTextSignature": "Signature: ",
                        "styleSignature": "body",
                        "fontSizeSignature": "16px",
                        "lineHeightSignature": "19px",
                        "fontStyleSignature": "normal",
                        "labelTextDate": "Date: ",
                        "styleDate": "body",
                        "fontSizeDate": "16px",
                        "lineHeightDate": "19px",
                        "fontStyleDate": "normal",
                        "dateWidth": "40",
                        "spacing": "80px"
                    },
                    "Includes": {
                        "Date": true
                    },
                    "Style": {}
                }
            }
        ],
        "Migration": {
            "itemSignature": true
        }
    },
    /*
    {
        "Name": "Contemporary",
        "IsDefault": true,
        "Type": "certificates",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "PageHeaderBlocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "430px",
                        "maxHeight": ""
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            }
        ],
        "Blocks": [
            {
                "Id": "text-default",
                "Type": "text",
                "Config": {
                    "Block": {
                        "displayText": "Statement of Value",
                        "style": "body",
                        "fontStyle": "normal"
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "itemContainer-default",
                "Type": "itemContainer",
                "Config": {
                    "Block": {
                        "col1_width": "100"
                    },
                    "Style": {}
                },
                "Columns": [
                    [
                        {
                            "Id": "columnsTwo-default",
                            "Type": "columnsTwo",
                            "Config": {
                                "Block": {
                                    "col1_width": "",
                                    "col1_verticalAlign": "middle",
                                    "col1_collapseIfEmpty": false,
                                    "col2_width": "500px",
                                    "col2_verticalAlign": "top",
                                    "col2_collapseIfEmpty": false,
                                    "col1_paddingRight": "10px"
                                },
                                "Header": {
                                    "renderHeaderOnlyFirst": false,
                                    "col1_style": "body",
                                    "col1_fontStyle": "normal",
                                    "col1_verticalAlign": "middle",
                                    "col1_textAlign": "left",
                                    "col2_style": "body",
                                    "col2_fontStyle": "normal",
                                    "col2_verticalAlign": "middle",
                                    "col2_textAlign": "left"
                                },
                                "Style": {}
                            },
                            "Columns": [
                                [
                                    {
                                        "Id": "itemArtist-default",
                                        "Type": "itemArtist",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Artist: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemTitle-default",
                                        "Type": "itemTitle",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Title: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Includes": {
                                                "Edition": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemYear-default",
                                        "Type": "itemYear",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Year: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Year": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemMedium-default",
                                        "Type": "itemMedium",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Medium: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Medium": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSignature-default",
                                        "Type": "itemSignature",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Signature: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Signature": false
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemDimensions-default",
                                        "Type": "itemDimensions",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Size: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Dimensions": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemPrice-default",
                                        "Type": "itemPrice",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Price: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Price": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            },
                                            "Format": {
                                                "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemNumber-default",
                                        "Type": "itemNumber",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "Inventory #: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "Number": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    },
                                    {
                                        "Id": "itemSKU-default",
                                        "Type": "itemSKU",
                                        "Config": {
                                            "Block": {
                                                "displayType": "columns",
                                                "textLabel": "SKU: ",
                                                "styleLabel": "body",
                                                "fontStyleLabel": "normal",
                                                "columnWidthLabel": "105px",
                                                "textAlignLabel": "left",
                                                "styleValue": "body",
                                                "fontStyleValue": "normal",
                                                "textTransformValue": "none",
                                                "textAlignValue": "left"
                                            },
                                            "Visibility": {
                                                "SKU": true
                                            },
                                            "Style": {
                                                "textAlign": "left"
                                            }
                                        }
                                    }
                                ],
                                [
                                    {
                                        "Id": "itemImage-default",
                                        "Type": "itemImage",
                                        "Config": {
                                            "Block": {
                                                "maxWidth": "500px",
                                                "maxHeight": "100%"
                                            },
                                            "Style": {
                                                "textAlign": "center"
                                            }
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "Id": "separator-default",
                            "Type": "separator",
                            "Config": {
                                "Block": {
                                    "color": "#e9e9e9"
                                },
                                "Style": {
                                    "paddingTop": "20px",
                                    "paddingBottom": "20px"
                                }
                            }
                        },
                        {
                            "Id": "itemArtistBio-default",
                            "Type": "itemArtistBio",
                            "Config": {
                                "Block": {
                                    "borderBottom": "1px solid #e9e9e9",
                                    "borderBottomSpacing": "20px",
                                    "styleName": "body",
                                    "fontStyleName": "normal",
                                    "textTransformName": "none",
                                    "styleBio": "body",
                                    "fontStyleBio": "normal",
                                    "textTransformBio": "none"
                                },
                                "Includes": {
                                    "ArtistName": true
                                },
                                "Visibility": {
                                    "ArtistBio": true
                                },
                                "Style": {
                                    "paddingBottom": "20px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "statement-default",
                "Type": "statement",
                "Config": {
                    "Block": {
                        "borderBottom": "1px solid #e9e9e9",
                        "borderBottomSpacing": "20px",
                        "style": "body",
                        "fontStyle": "normal",
                        "textTransform": "none"
                    },
                    "Style": {
                        "paddingBottom": "20px",
                        "textAlign": "left"
                    }
                }
            },
            {
                "Id": "signature-default",
                "Type": "signature",
                "Config": {
                    "Block": {
                        "labelTextSignature": "Signature: ",
                        "styleSignature": "body",
                        "fontSizeSignature": "16px",
                        "lineHeightSignature": "19px",
                        "fontStyleSignature": "normal",
                        "labelTextDate": "Date: ",
                        "styleDate": "body",
                        "fontSizeDate": "16px",
                        "lineHeightDate": "19px",
                        "fontStyleDate": "normal",
                        "dateWidth": "40",
                        "spacing": "80px"
                    },
                    "Includes": {
                        "Date": true
                    },
                    "Style": {}
                }
            }
        ],
        "Migration": {
            "itemSignature": true
        }
    }
    */
]

module.exports = Templates;